import React, { useEffect, useState, useRef } from "react";
import "./Chat.css";
import Avatar from "@mui/material/Avatar";
import { InsertEmoticon, Mic } from "@mui/icons-material";
import { MoreVert } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { useParams } from "react-router-dom";
import db from "../../../Firebase/Firebase-config";
import firebase from "firebase/compat/app";
import { useUserAuth } from "../../../Context/UseAuthContext";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";

import ProfileNavbar from "../../Navbar/ProfileNavbar";

function Chat() {
  const [seed, setSeed] = useState("");
  const [input, setinput] = useState("");
  const { roomId } = useParams();
  const [roomName, setRoomName] = useState("");
  const [messages, setMessages] = useState([]);
  const [emoji, setEmoji] = useState(false);
  const scrollRef = useRef();

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const addEmoji = (e) => {
    let emoji = e.native;
    setinput(input + emoji);
  };
  const checkEmojiClose = () => {
    if (emoji) {
      setEmoji(false);
    } 
  };

  const { currentUser } = useUserAuth();
  //console.log(currentUser);

  useEffect(() => {
    setSeed(Math.floor(Math.random() * 5000));

    if (roomId) {
      db.collection("rooms")
        .doc(roomId)
        .onSnapshot((snapshot) => {
          setRoomName(snapshot.data().name);

          db.collection("rooms")
            .doc(roomId)
            .collection("messages")
            .orderBy("timestamp", "asc")
            .onSnapshot((snapshot) => {
              setMessages(snapshot.docs.map((doc) => doc.data()));
            });
        });
    }
  }, [roomId]);

  const sendMessage = (e) => {
    e.preventDefault();

    db.collection("rooms").doc(roomId).collection("messages").add({
      messages: input,
      name: currentUser.displayName,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
    });
    setinput("");
  };
  //console.log(messages);

  return (
    <>
      <ProfileNavbar />
      <div className="chat-outer">
        <div className="chat">
          <div className="chat__header">
            <Avatar
              src={`https://avatars.dicebear.com/api/initials/${roomName}.svg`}
            />
            <div className="chart__headerInfo">
              <h3>{roomName}</h3>
              <p>
                Last active at{" "}
                {new Date(
                  messages[messages.length - 1]?.timestamp?.toDate()
                ).toUTCString()}
              </p>
            </div>

            <div className="chat__hearRight">
              <IconButton className="icon">
                <NotificationsIcon />
              </IconButton>
              <IconButton className="icon">
                <MoreVert /> 
              </IconButton>
            </div>
          </div>
          <div className="chat__body">
            {messages.map((message, index) => (
              <p
                className={`chat__message ${message.name === currentUser.displayName ? 'chat__reciever' : ""}
                 ${message.messages === message.name + ` has joined the chat` ? "chat__alert" : ""}`}
                key={index}
                ref={scrollRef}
              >
                <span className="chat__name">{message.name}</span>
                {message.messages}
                <span className="chat__timestamp">
                  {new Date(message.timestamp?.toDate()).toUTCString()}
                </span>
              </p>
            ))}
          </div>

          <div className="chat__footer">
            <IconButton>
              <InsertEmoticon
                style={{ color: "#00b7ff" }}
                className="yellow"
                onClick={() => setEmoji(!emoji)}
              />
              {emoji ? <Picker onSelect={addEmoji} /> : null}
            </IconButton>
            <form>
              <input
                type="text"
                value={input}
                onClick={checkEmojiClose}
                onChange={(e) => setinput(e.target.value)}
                placeholder="Type a message"
              />

              <button type="submit" onClick={sendMessage}>
                Send
              </button>
            </form>
            <Mic />
          </div>
        </div>
      </div>
    </>
  );
}

export default Chat;
